<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      
        <div class="vx-row">
        <!-- CARD 1: CONGRATS -->
      
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
                    <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Bonjour {{ this.$store.state.AppActiveUser.nom }},</h1>
        </vx-card>
      </div>    
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="subscribersGained.analyticsData"
                  icon="UsersIcon"
                  :statistic="this.$store.state.statistic.candidats[0].total | k_formatter"
                  statisticTitle="Candidats"
                  :chartData="this.$store.state.statistic.candidats"
                  type='area' >
                  
                  </statistics-card-line>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="subscribersGained.analyticsData"
                  icon="UsersIcon"
                  :statistic="this.$store.state.statistic.formateurs[0].total | k_formatter"
                  statisticTitle="Formateurs"
                  :chartData="this.$store.state.statistic.formateurs"
                  type='area' >
                  
                  </statistics-card-line>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="ordersRecevied.analyticsData"
                  icon="ListIcon"
                  :statistic="this.$store.state.statistic.formations[0].total | k_formatter"
                  statisticTitle="Formations"
                  :chartData="this.$store.state.statistic.formations"
                  color='warning'
                  type='area' />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="ordersRecevied.analyticsData"
                  icon="ListIcon"
                  :statistic="this.$store.state.statistic.domaines[0].total | k_formatter"
                  statisticTitle="Domaines"
                  :chartData="this.$store.state.statistic.domaines"
                  color='warning'
                  type='area'/>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="revenueGenerated.analyticsData"
                  icon="DollarSignIcon"
                  :statistic="this.$store.state.statistic.gains[0].total+ ' '+ 'DT' "
                  statisticTitle="Recu des paiements"
                  :chartData="this.$store.state.statistic.gains"
                  color='success'
                  type='area'/>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="quarterlySales.analyticsData"
                  icon="DollarSignIcon"
                  :statistic="this.$store.state.statistic.salaire_formateur[0].total+this.$store.state.statistic.salaire_formateur[0].depensestotal+ ' '+ 'DT'"
                  statisticTitle="Total des dépenses"
                  :chartData="this.$store.state.statistic.salaire_formateur"
                  color='danger'
                  type='area' />
            </div>
            <!--div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="revenueGenerated.analyticsData"
                  icon="DollarSignIcon"
                  :statistic="this.$store.state.statistic.gains[0].total-this.$store.state.statistic.salaire_formateur[0].total"
                  statisticTitle="Le bénéfice"
                  :chartData="opts"
                  color='success'
                  type='area' />
                    
            </div-->
            
        </div>
        <!--div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="subscribersGained.analyticsData"
                  icon="UsersIcon"
                  :statistic="this.$store.state.statistic.candidats[0].total | k_formatter"
                  statisticTitle="Candidats"
                  :chartData="this.$store.state.statistic.candidats"
                  type='area' >
                  
                  </statistics-card-line>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="revenueGenerated.analyticsData"
                  icon="DollarSignIcon"
                  :statistic="this.$store.state.statistic.candidats[0].total | k_formatter"
                  statisticTitle="Revenue Generated"
                  :chartData="this.$store.state.statistic.candidats"
                  color='success'
                  type='area' />
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="quarterlySales.analyticsData"
                  icon="ShoppingCartIcon"
                  :statistic="quarterlySales.analyticsData.sales"
                  statisticTitle="Quarterly Sales"
                  :chartData="quarterlySales.series"
                  color='danger'
                  type='area' />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="ordersRecevied.analyticsData"
                  icon="ShoppingBagIcon"
                  :statistic="ordersRecevied.analyticsData.orders | k_formatter"
                  statisticTitle="Orders Received"
                  :chartData="ordersRecevied.series"
                  color='warning'
                  type='area' />
            </div>
        </div-->
        <vx-card ref="filterCard"  class="user-list-filters mb-8" >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <span class="text-m opacity-100">Filter par année</span>
          <datepicker  v-model="data_date" :minimumView="'year'" :maximumView="'year'"></datepicker>
        </div>
        
        
        
      </div>
    </vx-card>
        <div class="vx-row">

            <!-- LINE CHART -->
            <div class="vx-col w-full md:w-2/3 mb-base">
                <vx-card title="Le bénéfice des formations">
                    <template slot="actions">
                        <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template>
                    <div slot="no-body" class="p-6 pb-0">
                        <div class="flex" v-if="revenueComparisonLine.analyticsData">
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">cette année</p>
                                <p class="text-3xl text-success">{{ this.$store.state.statistic.GainsanneeFormations[0].total }}<sup class="text-base mr-1">DT</sup></p>
                            </div>
                            <div>
                                <p class="mb-1 font-semibold">année présédente</p>
                                <p class="text-3xl">{{ this.$store.state.statistic.GainsanneeFormations[1].total }}<sup class="text-base mr-1">DT</sup></p>
                            </div>
                        </div>
                        <vue-apex-charts
                          type=line
                          height=266
                          :options="analyticsData.salesLine.chartOptions"
                          :series="this.$store.state.statistic.GainsanneeFormations" />
                    </div>
                </vx-card>
            </div>
            
            <!-- RADIAL CHART -->
            <div class="vx-col w-full md:w-1/3 mb-base">
                <vx-card>
                    <template slot="no-body" >
                        <div class="p-8 clearfix">
                            <div>
                                <h3>
                                  <span>Rapport des paiements en attente</span>
                                </h3>
                                
                            </div>
                            
                              <div class="flex mt-6"  >
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">Reçu</p>
                                <p class="text-3xl text-success">{{ this.$store.state.statistic.gains[0].totaltotal-this.$store.state.statistic.gains[0].total }}<sup class="text-base mr-1">DT</sup></p>
                            </div>
                            <div class="ml-6">
                                <p class="mb-1 font-semibold">Salaires</p>
                                <p class="text-3xl text-danger">{{ (this.$store.state.statistic.salaire_formateur[0].totaltotal)-(this.$store.state.statistic.salaire_formateur[0].total)  }}<sup class="text-base mr-1">DT</sup></p>
                            </div>
                        </div>
                            
                            
                              <div class="flex mt-6" >
                            <div class="mr-6">
                                <p class="mb-1 font-semibold">bénéfice</p>
                                <p class="text-3xl text-success" :class="(this.$store.state.statistic.gains[0].totaltotal-this.$store.state.statistic.gains[0].total)-(this.$store.state.statistic.salaire_formateur[0].totaltotal-this.$store.state.statistic.salaire_formateur[0].total) >= 0 ? 'text-success' : 'text-danger'">{{ (this.$store.state.statistic.gains[0].totaltotal-this.$store.state.statistic.gains[0].total)-(this.$store.state.statistic.salaire_formateur[0].totaltotal-this.$store.state.statistic.salaire_formateur[0].total) }}<sup class="text-base mr-1">DT</sup></p>
                            </div>
                            
                        </div>
                            
                            
                        </div>
                        <div class="p-8 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                            <div class="mb-4">
                                <small>Reçu</small>
                                <vs-progress :percent="(this.$store.state.statistic.gains[0].totaltotal-this.$store.state.statistic.gains[0].total)*100/this.$store.state.statistic.gains[0].totaltotal" color="success"></vs-progress>
                            </div>
                            <div>
                                <small>Salaires</small>
                                <vs-progress :percent="(this.$store.state.statistic.salaire_formateur[0].totaltotal-this.$store.state.statistic.salaire_formateur[0].total)*100/this.$store.state.statistic.salaire_formateur[0].totaltotal" color="danger"></vs-progress>
                            </div>
                            
                        </div>
                    </template>
                </vx-card>
            </div>
        </div>

        <!-- {{this.$store.state.statistic.participationsFormations}} -->
        <div class="vx-row">

            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
                <vx-card title="Participation par domaine">
                    <div v-for="(browser, index) in this.$store.state.statistic.participationsDomaines" :key="browser.id" :class="{'mt-4': index}">
                        <div class="flex justify-between">
                            <div class="flex flex-col">
                                <span class="mb-1">{{ browser.titre }}</span>
                                <h4>{{(browser.partisipation*100/browser.partisipationtotal).toFixed(2)}}%</h4>
                            </div>
                            <!--div class="flex flex-col text-right">
                                <span class="flex -mr-1">
                                    <span class="mr-1">{{ browser.comparedResult }}</span>
                                    <feather-icon :icon=" browser.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[browser.comparedResult < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
                                </span>
                                <span class="text-grey">{{ browser.time | time(true) }}</span>
                            </div-->
                        </div>
                        <vs-progress :percent="browser.partisipation * 100 / browser.partisipationtotal" :color="getPopularityColor(browser.partisipation * 100 / browser.partisipationtotal)"></vs-progress>
                        
                    </div>
                     
                </vx-card>
                

            </div>

            <div class="vx-col w-full md:w-2/3 mb-5">
                
                <vx-card title="Participation de candidat a formation">
                    <div class="flex">
                        <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>Nouveau participation</span></span>
                        <span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>Fin participation</span></span>
                    </div>
                    <vue-apex-charts type=bar height=277 :options="analyticsData.clientRetentionBar.chartOptions" :series="this.$store.state.statistic.participations" />
                </vx-card>
            </div>
            

        </div>
         
        <div class="vx-row">
            <!-- Sessions By Device -->
            <!--div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
                <vx-card title="Sessions By Device">
                    < SLOT = ACTIONS comonter>
                    <template slot="actions">
                        <change-time-duration-dropdown />
                    </template>

                    <div slot="no-body">
                        <vue-apex-charts class="mt-6 mb-8" type=donut height=325 :options="analyticsData.sessionsByDeviceDonut.chartOptions" :series="sessionsData.series" />
                    </div>

                    <ul class="mt-6">
                        <li v-for="deviceData in sessionsData.analyticsData" :key="deviceData.device" class="flex mb-3">
                            <feather-icon :icon="deviceData.icon" :svgClasses="[`h-5 w-5 stroke-current text-${deviceData.color}`]"></feather-icon>
                            <span class="ml-2 inline-block font-semibold">{{ deviceData.device }}</span>
                            <span class="mx-2">-</span>
                            <span class="mr-4">{{ deviceData.sessionsPercentage }}%</span>
                            <div class="ml-auto flex -mr-1">
                            <span class="mr-1">{{ deviceData.comparedResultPercentage }}%</span>
                            <feather-icon :icon=" deviceData.comparedResultPercentage < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[deviceData.comparedResultPercentage < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
                            </div>
                        </li>
                    </ul>
                </vx-card>
                
            </div-->

            <!-- CHAT CARD 
            <div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
                <vx-card title="Chat" class="overflow-hidden">
                    <template slot="no-body">
                        <div class="chat-card-log">
                            <VuePerfectScrollbar ref="chatLogPS" class="scroll-area pt-6 px-6" :settings="settings" :key="$vs.rtl">
                                <ul ref="chatLog">
                                        <li class="flex items-start" :class="{'flex-row-reverse': msg.isSent, 'mt-4': index}" v-for="(msg, index) in chatLog" :key="index">
                                            <vs-avatar size="40px" class="m-0 flex-shrink-0" :class="msg.isSent ? 'ml-5' : 'mr-5'" :src="msg.senderImg"></vs-avatar>
                                            <div class="msg relative bg-white shadow-md py-3 px-4 mb-2 rounded-lg max-w-md" :class="{'chat-sent-msg bg-primary-gradient text-white': msg.isSent, 'border border-solid d-theme-border-grey-light': !msg.isSent}">
                                                <span>{{ msg.msg }}</span>
                                            </div>
                                        </li>
                                </ul>
                            </VuePerfectScrollbar>
                        </div>
                        <div class="flex bg-white chat-input-container p-6">
                            <vs-input class="mr-3 w-full" v-model="chatMsgInput" @keyup.enter="chatMsgInput = ''" placeholder="Type Your Message" ></vs-input>
                            <vs-button icon-pack="feather" icon="icon-send" @click="chatMsgInput = ''"></vs-button>
                        </div>
                    </template>
                </vx-card>
            </div>-->


            <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
                <vx-card title="Participation par formation">
                    <div v-for="(browser, index) in this.$store.state.statistic.participationsFormations" :key="browser.id" :class="{'mt-4': index}">
                        <div class="flex justify-between">
                            <div class="flex flex-col">
                                <span class="mb-1">{{ browser.titre }}</span>
                                <h4>{{(browser.partisipation*100/browser.partisipationtotal).toFixed(2)}}%</h4>
                            </div>
                            <!--div class="flex flex-col text-right">
                                <span class="flex -mr-1">
                                    <span class="mr-1">{{ browser.comparedResult }}</span>
                                    <feather-icon :icon=" browser.comparedResult < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[browser.comparedResult < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
                                </span>
                                <span class="text-grey">{{ browser.time | time(true) }}</span>
                            </div-->
                        </div>
                        <vs-progress :percent="browser.partisipation * 100 / browser.partisipationtotal" :color="getPopularityColor(browser.partisipation * 100 / browser.partisipationtotal)"></vs-progress>
                        
                    </div>
                     
                </vx-card>

            </div>
            <!-- CUSTOMERS CHART -->
            <div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
                <vx-card title="Bénéfice par formation">
                    <!-- SLOT = ACTIONS -->
                    <template slot="actions">
                        
                    </template>
                    
                    <div slot="no-body">
                        <!-- CHART -->
                        <vue-apex-charts type=pie height=345 class="mt-10 mb-10" :options='{"labels":this.$store.state.statistic.GainsFormations.labels, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "type": "pie", "offsetY": 0, "dropShadow": { "enabled": false, "blur": 5, "left": 1, "top": 1, "opacity": 0.2 }, "toolbar": { "show": false } }, "stroke": { "width": 5 }, "colors": [ "#7961F9", "#FF9F43", "#EA5455", "#20c997" ], "fill": { "type": "gradient", "gradient": { "gradientToColors": [ "#9c8cfc", "#FFC085", "#f29292" ] } } }' :series="this.$store.state.statistic.GainsFormations.data" />

                        <!-- CHART DATA -->
                        <ul class="mb-1">
                            <li v-for="customerData in this.$store.state.statistic.GainsFormations.forma" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                <span class="flex items-center">
                                    <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
                                    <span class="font-semibold">{{ customerData.customerType }}</span>
                                </span>
                                <span>{{ customerData.counts }}</span>
                            </li>
                        </ul>
                    </div>

                </vx-card>
            </div>
            
            <div class="vx-col w-full lg:w-1/3 lg:mt-0 mt-base">
                <vx-card title="Bénéfice par domaine">
                    <!-- SLOT = ACTIONS -->
                    <template slot="actions">
                        
                    </template>

                    <div slot="no-body">
                        <!-- CHART -->
                        <vue-apex-charts type=pie height=345 class="mt-10 mb-10" :options='{ "labels": this.$store.state.statistic.GainsDomaines.labels, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "type": "pie", "offsetY": 0, "dropShadow": { "enabled": false, "blur": 5, "left": 1, "top": 1, "opacity": 0.2 }, "toolbar": { "show": false } }, "stroke": { "width": 5 }, "colors": [ "#7961F9", "#FF9F43", "#EA5455", "#20c997" ], "fill": { "type": "gradient", "gradient": { "gradientToColors": [ "#9c8cfc", "#FFC085", "#f29292" ] } } }' :series="this.$store.state.statistic.GainsDomaines.data" />

                        <!-- CHART DATA -->
                        <ul class="mb-1">
                            <li v-for="customerData in this.$store.state.statistic.GainsDomaines.forma" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                <span class="flex items-center">
                                    <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
                                    <span class="font-semibold">{{ customerData.customerType }}</span>
                                </span>
                                <span>{{ customerData.counts }}</span>
                            </li>
                        </ul>
                    </div>

                </vx-card>
            </div>

            
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import modulestatistic from '@/store/Statistic/modulestatistic.js'
export default{
    data() {
        return {
            configFromdateTimePicker: {
              minDate: new Date(),
              maxDate: null
            },
            formation_labels:null,
            domain_labels:null,
            autreporcent:0,
            autreporcent:0,
            total:null,
            gains:[],
            opts:[],
            subscribersGained: {},
            revenueGenerated: {},
            quarterlySales: {},
            ordersRecevied: {},

            revenueComparisonLine: {},
            goalOverview: {},

            browserStatistics: [],
            clientRetentionBar: {},

            sessionsData: {},
            chatLog: [],
            chatMsgInput: '',
            customersData: {},

            analyticsData: analyticsData,
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    components: {
        VueApexCharts,
        StatisticsCardLine,
        VuePerfectScrollbar,
        ChangeTimeDurationDropdown,
        Datepicker
    },
    mounted() {
        this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
    },
    computed: {
        data_date: {
        get() {
            
        },
        set(val) {
            
            this.$store.dispatch("statistic/fetchFormateur_salaire",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchGain",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchCandidat",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchFormateur",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchFormation",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchDomaine",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchParticipation",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchParticipationFormation",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchParticipationDomaine",val).catch(err => { console.error(err) })
            this.$store.dispatch("statistic/fetchFormationGain",val).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchDomaineGain",val).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchAnneeFormationGain",val).catch(err => { console.error(err) })
        }
        },
        candidats() {
            console.log(this.$store.state.statistic.candidats)
            return this.$store.state.statistic.candidats[0]
        },
       
    },
    methods: {

    getPopularityColor(num) {
        // analyticsData.customersPie.chartOptions.labels[0]=this.$store.state.statistic.GainsFormations.forma[0].customerType
        //  analyticsData.customersPie.chartOptions.labels[1]=this.$store.state.statistic.GainsFormations.forma[1].customerType
        //  analyticsData.customersPie.chartOptions.labels[2]=this.$store.state.statistic.GainsFormations.forma[2].customerType
        //  analyticsData.customersPie.charttOptions.labels[0]=this.$store.state.statistic.GainsDomaines.forma[0].customerType
        //  analyticsData.customersPie.charttOptions.labels[1]=this.$store.state.statistic.GainsDomaines.forma[1].customerType
        //  analyticsData.customersPie.charttOptions.labels[2]=this.$store.state.statistic.GainsDomaines.forma[2].customerType
      if(num > 40) return "success"
      if(num >20) return "primary"
      if(num >= 10) return "warning"
      if(num < 5) return "danger"
      return "primary"
    },},
    created() {
        //statistic
        this.$vs.loading({type:'material'});
        
        /*this.$vs.loading({ color: this.colorLoading })*/
        // setTimeout(() => {}, 5500);
        
         
        if(!modulestatistic.isRegistered) {
        this.$store.registerModule('statistic', modulestatistic)
        modulestatistic.isRegistered = true
        }
       const debit_value="0"
       this.$store.dispatch("statistic/fetchGain",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormateur_salaire",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchCandidat",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormateur",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormation",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchDomaine",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchParticipation",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchParticipationFormation",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchParticipationDomaine",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchFormationGain",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchDomaineGain",debit_value).catch(err => { console.error(err) })
       this.$store.dispatch("statistic/fetchAnneeFormationGain",debit_value).catch(err => { console.error(err) })
       
       console.log('1',this.$store.state.statistic.candidats)
       //console.log('12',this.$store.state.statistic.formateurs)
      // Subscribers gained - Statistics
      this.$http.get("/api/card/card-statistics/subscribers")
        .then((response) => { this.subscribersGained = response.data })
        .catch((error) => { console.log(error) })

      // Revenue Generated
      this.$http.get("/api/card/card-statistics/revenue")
        .then((response) => { this.revenueGenerated = response.data })
        .catch((error) => { console.log(error) })

      // Sales
      this.$http.get("/api/card/card-statistics/sales")
        .then((response) => { this.quarterlySales = response.data })
        .catch((error) => { console.log(error) })

      // Orders - Statistics
      this.$http.get("/api/card/card-statistics/orders")
        .then((response) => { this.ordersRecevied = response.data })
        .catch((error) => { console.log(error) })

      // Revenue Comparison
      this.$http.get("/api/card/card-analytics/revenue-comparison")
        .then((response) => { this.revenueComparisonLine = response.data })
        .catch((error) => { console.log(error) })
     
      // Goal Overview
      this.$http.get("/api/card/card-analytics/goal-overview")
        .then((response) => { this.goalOverview = response.data })
        .catch((error) => { console.log(error) })

      // Browser Analytics
      this.$http.get("/api/card/card-analytics/browser-analytics")
        .then((response) => { this.browserStatistics = response.data })
        .catch((error) => { console.log(error) })

      // Client Retention
      this.$http.get("/api/card/card-analytics/client-retention")
        .then((response) => { this.clientRetentionBar = response.data })
        .catch((error) => { console.log(error) })

      // Sessions By Device
      this.$http.get("/api/card/card-analytics/session-by-device")
        .then((response) => { this.sessionsData = response.data })
        .catch((error) => { console.log(error) })

      // Chat Log
      this.$http.get("/api/chat/demo-1/log")
        .then((response) => { this.chatLog = response.data })
        .catch((error) => { console.log(error) })

      // Customers
      this.$http.get("/api/card/card-analytics/customers")
        .then((response) => { this.customersData = response.data })
        .catch((error) => { console.log(error) })
         
        //  analyticsData.customersPie.chartOptions.labels[0]=this.$store.state.statistic.GainsFormations.forma[0].customerType
        //  analyticsData.customersPie.chartOptions.labels[1]=this.$store.state.statistic.GainsFormations.forma[1].customerType
        //  analyticsData.customersPie.chartOptions.labels[2]=this.$store.state.statistic.GainsFormations.forma[2].customerType
         
        //  analyticsData.customersPie.charttOptions.labels[0]=this.$store.state.statistic.GainsDomaines.forma[0].customerType
        //  analyticsData.customersPie.charttOptions.labels[1]=this.$store.state.statistic.GainsDomaines.forma[1].customerType
        //  analyticsData.customersPie.charttOptions.labels[2]=this.$store.state.statistic.GainsDomaines.forma[2].customerType
        this.formation_labels={"labels":this.$store.state.statistic.GainsFormations.labels, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "type": "pie", "offsetY": 0, "dropShadow": { "enabled": false, "blur": 5, "left": 1, "top": 1, "opacity": 0.2 }, "toolbar": { "show": false } }, "stroke": { "width": 5 }, "colors": [ "#7961F9", "#FF9F43", "#EA5455", "#20c997" ], "fill": { "type": "gradient", "gradient": { "gradientToColors": [ "#9c8cfc", "#FFC085", "#f29292" ] } } }
        this.domain_labels={ "labels": this.$store.state.statistic.GainsDomaines.labels, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "type": "pie", "offsetY": 0, "dropShadow": { "enabled": false, "blur": 5, "left": 1, "top": 1, "opacity": 0.2 }, "toolbar": { "show": false } }, "stroke": { "width": 5 }, "colors": [ "#7961F9", "#FF9F43", "#EA5455", "#20c997" ], "fill": { "type": "gradient", "gradient": { "gradientToColors": [ "#9c8cfc", "#FFC085", "#f29292" ] } } }
        setTimeout(() => {
            this.$vs.loading.close()
        }, 2000);
           
    }
}
</script>

<style lang="scss">
.chat-card-log {
    height: 400px;

    .chat-sent-msg {
        background-color: #f2f4f7 !important;
    }
}
.greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
</style>
